"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dashboardApi = exports.getCampaignStatus = exports.getCampaignActivity = exports.getActiveUsers = exports.getLaunchedCampaigns = exports.getLiveCampaigns = exports.getTagWeightHistory = exports.getTagPerformance = void 0;
const createApi_1 = require("../../../helpers/createApi");
const helpers_1 = require("./helpers");
const schemas_1 = require("./schemas");
const getTagPerformance = (caller) => ({ accountId, accounts, from, unit, v2 }) => caller(`/backend/accounts/${accountId}/dashboard/tag_performance`)
    .get({ accounts, from, unit, ...(v2 && { v2 }) })
    .then(helpers_1.transformTagPerformanceResponse);
exports.getTagPerformance = getTagPerformance;
const getTagWeightHistory = (caller) => ({ accountId, accounts, from, unit }) => caller(`/backend/accounts/${accountId}/dashboard/tag_history`).get({ accounts, from, unit });
exports.getTagWeightHistory = getTagWeightHistory;
const getLiveCampaigns = (caller) => ({ accountId, accounts }) => caller(`/backend/accounts/${accountId}/dashboard/live_campaigns`).get({ v2: true, accounts });
exports.getLiveCampaigns = getLiveCampaigns;
const getLaunchedCampaigns = (caller) => ({ accountId, accounts, from }) => caller(`/backend/accounts/${accountId}/dashboard/launched_campaigns`).get({ v2: true, accounts, _from: from });
exports.getLaunchedCampaigns = getLaunchedCampaigns;
const getActiveUsers = (caller) => ({ accountId, accounts }) => caller(`/backend/accounts/${accountId}/dashboard/active_users`).get({ v2: true, accounts });
exports.getActiveUsers = getActiveUsers;
const getCampaignActivity = (caller) => async ({ accountId, accounts, ...paginationParameters }) => caller(`/backend/accounts/${accountId}/dashboard/campaign_activity`).get({
    v2: true,
    accounts,
    ...paginationParameters,
});
exports.getCampaignActivity = getCampaignActivity;
const getCampaignStatus = (caller) => async ({ accountId, accounts }) => {
    const response = await caller(`/backend/accounts/${accountId}/dashboard/campaign_status`).get({
        accounts,
    });
    schemas_1.statusCardSchema.parse(response);
    return response;
};
exports.getCampaignStatus = getCampaignStatus;
exports.dashboardApi = (0, createApi_1.createAPIFactory)({
    getTagPerformance: exports.getTagPerformance,
    getTagWeightHistory: exports.getTagWeightHistory,
    getLiveCampaigns: exports.getLiveCampaigns,
    getLaunchedCampaigns: exports.getLaunchedCampaigns,
    getActiveUsers: exports.getActiveUsers,
    getCampaignActivity: exports.getCampaignActivity,
    getCampaignStatus: exports.getCampaignStatus,
});
//# sourceMappingURL=api.js.map